import { IAddress } from "@wingspanhq/users/dist/lib/interfaces";
import type { cardApiSpec } from "@wingspanhq/wingspan-api-types";
import { getValidationSchemaAddress } from "../../../shared/validators/address/validationSchemaAddress";

export const selectorCardShippingAddress = (
  address: IAddress | undefined
): cardApiSpec.ShippingAddress | undefined => {
  if (!address) {
    return undefined;
  }

  const country = address.country || "US";

  if (!getValidationSchemaAddress(country).isValidSync(address)) {
    return undefined;
  }

  return {
    address1: address.addressLine1!,
    ...(address.addressLine2 ? { address2: address.addressLine2 } : {}),
    city: address.city!,
    state: address.state!,
    postal_code: address.postalCode!,
    country
  };
};
